<div class="radio-buttons-with-dropdown btn-group d-flex d-md-inline-flex flex-column flex-md-row" role="group" aria-label="User title selector">
  <ng-container *ngFor="let button of radioButtons; let i=index">
    <input type="radio"
           class="btn-check"
           value="{{button.value}}"
           name="{{buttonValues.groupName}}"
           id="id-{{button?.id || i}}"
           autocomplete="off"
           [checked]="selectedValue === button.value"
    >
    <label
      [class.active]="selectedValue === button.value"
      [class.faded]="selectedValue && selectedValue !== button.value"
      (click)="writeValue(button.value)"
      [attr.yp-e2e-id]="button?.e2eId"
      class="radio-buttons btn btn-outline-primary w-100 text-left text-md-center radio-button_{{i+1}}"
      for="id-{{button?.id || i}}"
    >
      {{button.label}}
    </label>
  </ng-container>
  <select
    class="form-select radio-dropdown"
    (change)="writeValue($event.target.value)"
    [class.active]="dropdownValue === selectedValue"
    [class.faded]="selectedValue && selectedValue !== dropdownValue"
    *ngIf="dropdownButtons.length > 0"
    [value]="dropdownValue"
    name="select"
    id="select"
    [attr.yp-e2e-id]="'radio-dropdown-select'">
    <option disabled [value]="null" [selected]="dropdownValue === null">Other</option>
    <ng-container *ngFor="let button of dropdownButtons">
      <option
        [value]="button.value" [id]="button?.id"
        [selected]="dropdownValue === button.value"
        [attr.yp-e2e-id]="button?.e2eId"
      >
        {{button.label}}
      </option>
    </ng-container>
  </select>
</div>
